import React from 'react';
import queryString from 'query-string';
import { Button, Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'toolboxOauthTest';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value
      }, this.parameters
    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        this.setState({ onLogin: false, error: { open: true, message: error.message } });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div ref={this.ref}>
          <Form onSubmit={event => this.onSubmit(event)}>
            <input
              className="form-control user-input"
              disabled={this.state.onLogin}
              placeholder={translate('PlaceholderUserName')}
              ref={(ref) => {
                this.usernameInput = ref;
              }
              }
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              id="username"
            />
            <input
              className="form-control pass-input"
              required={true}
              disabled={this.state.onLogin}
              placeholder={translate('PlaceholderPassword')}
              ref={(ref) => {
                this.passwordInput = ref;
              }
              }
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="password"
            />
            <div className="buttons">
              {!this.state.onLogin ?
                <Button
                  block={!this.parameters.failureRedirect}
                  color="danger"
                  size="lg"
                  tabIndex={1}
                  type="submit"
                  id="submmit"
                  disabled={!this.props.turnstileSuccess}
                >
                  {translate('ButtonEnter')}
                </Button> :
                <Progress animated color="danger" value={100} />}
              {this.parameters.failureRedirect && !this.state.onLogin ?
                <Button
                  color="danger"
                  className="volver"
                  href={this.parameters.failureRedirect}
                  size="lg"
                  id="back"
                >
                  {translate('ButtonBack')}
                </Button> : null}
            </div>
            <div className="messages-container">
              <Alert color="danger" id="error-message" isOpen={this.state.error.open} toggle={() => this.setState({ error: { open: false } })}>
                {this.state.error.message}
              </Alert>
            </div>
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { style: { marginTop: '2rem' } });
